import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Extrema feature parameters */
export interface ExtremaParams {
  /** Reference to parent function element */
  of: string;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const EXTREMA_DEFAULT_PARAMS: Omit<ExtremaParams, 'of'> = {};

/**
 * Default theme for extrema feature.
 * - Green circles for maxima
 * - Red circles for minima
 * - Amber circles for vertex (quadratic)
 */
export const EXTREMA_DEFAULTS: FeatureStyleNode = {
  point: { fixed: true },
  subparts: {
    maxima: { point: { color: 'green', face: 'o' } },
    minima: { point: { color: 'red', face: 'o' } },
    vertex: { point: { color: 'amber', face: 'o' } },
  },
};
